import {Component, ElementRef, Input, ViewContainerRef} from '@angular/core'
import {LaunchDialogService} from '@spartacus/storefront'
import {take} from 'rxjs/operators'
import {EbAnalyticsService} from 'src/app/features/analytics/services/facades/eb-analytics.service'
import {EbFavorites, EbGroupedFavorites} from '../../features/favorites/interfaces/eb-favorites.interface'
import {EbFavoritesService} from '../../features/favorites/services/facades/eb-favorites.service'
import {EbProduct, EbProductPrice} from '../../features/product/interfaces/eb-product.interface'

@Component({
    selector: 'eb-grouped-favorites',
    templateUrl: './eb-grouped-favorites.component.html',
    styleUrls: ['./eb-grouped-favorites.component.scss'],
    standalone: false
})
export class EbGroupedFavoritesComponent {
  @Input() grouped: EbGroupedFavorites
  @Input() product: EbProduct
  @Input() price: EbProductPrice

  constructor(
    protected favoritesService: EbFavoritesService,
    protected modalService: LaunchDialogService,
    protected vcr: ViewContainerRef,
    protected ebElement: ElementRef,
    protected ebAnalyticsService: EbAnalyticsService
  ) {}

  toggleProductInFavorites(favorites: EbFavorites) {
    if (favorites.containsProduct) {
      this.favoritesService.removeProductFromFavorites(this.product.code, favorites)
    } else {
      this.favoritesService.addProductToFavorites(this.product.code, favorites)
      this.triggerAnalyticsEvent()
    }
  }

  addProductToNewFavorites() {
    this.modalService
      .openDialog('ADDED_PRODUCT_FAVORITE', this.ebElement, this.vcr)
      ?.pipe(take(1))
      .subscribe(name => {
        this.favoritesService
          .takeFavoritesByName(name)
          .subscribe(favorites => this.toggleProductInFavorites(favorites))
      })
  }

  triggerAnalyticsEvent(){
    if(this.product.orderable === true){
      this.ebAnalyticsService.addToFavorites(this.price?.items[0]?.itemNetPricePerUnit?.value.toString())
    } else {
      this.ebAnalyticsService.addToFavorites("0")
    }
  }
}
